export const resolveFormInputErrorMessage = (errorMessage: string, hash: string, inputName: string): string =>
  errorMessage.replace(hash, inputName);
